import { render } from "./EmailSearch.vue?vue&type=template&id=0bd4f7aa"
import script from "./EmailSearch.vue?vue&type=script&lang=js"
export * from "./EmailSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__